import {View} from 'MWC';
import tpl from '../templates/downloadApp/downloadApp.d';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }

    static displayName = 'Cards.Views.DownloadApp';
}
